import { render } from "./dbfx.vue?vue&type=template&id=5e4832f2&scoped=true&ts=true"
import script from "./dbfx.vue?vue&type=script&lang=ts"
export * from "./dbfx.vue?vue&type=script&lang=ts"

import "./dbfx.vue?vue&type=style&index=0&id=5e4832f2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4832f2"]])

export default __exports__